<!-- src/components/BackendLogin.vue -->
<template>
  <div class="container">
    <div v-if="loading">{{ $t('Loading...') }}</div>
    <div v-else-if="error">Error: {{ error.message }}</div>
    <form @submit.prevent="login">
      <label>{{ $t('Username') }}</label>
      <div class="input-with-icon">
        <el-input type="text" v-model="username" :placeholder="$t('Phone Number')" class="input-common"
          @keyup.enter="login"></el-input>
        <!-- <el-button
          icon="el-icon-copy-document"
          circle
          size="small"
          @click="copyPhoneNumber"
          title="Copy Phone Number"
          class="copy-button"
        ></el-button> -->
      </div>
      <label>{{ $t('Password') }}</label>
      <el-input type="password" v-model="password" :placeholder="$t('Password')" class="input-common"
        @keyup.enter="login"></el-input>
      <el-checkbox v-model="remember">
        {{ $t('Remember me') }}
      </el-checkbox>
      <el-button type="primary" @click="login" :disabled="loading" class="btn">{{ $t('Login') }}</el-button>
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <el-button link type="primary" @click="register" :disabled="loading" class="btn">{{ $t('Register') }}</el-button>
        <el-button link type="primary" @click="forgotPassword" :disabled="loading" class="btn">{{ $t('Forgot password') }}</el-button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import { BACKEND_URL } from '../../../share-source/src/config/config.js'; // Adjust the path as necessary
import { useUserStore } from '../stores/Global.js';
import { ElMessage } from 'element-plus'; // Import ElMessage

export default {
  name: 'BackendLogin',
  setup() {
    const userStore = useUserStore()
    return {
      userStore
    }
  },
  data() {
    return {
      username: '',
      password: '',
      data: null,
      loading: false,
      error: null,
      remember: false
    };
  },
  mounted() {
    this.userStore.logout();
    // console.log('userStore', this.userStore);
    // if (this.userStore.isAuthenticated) {
      // this.$router.push('/course-list');
      // this.$router.push('/');
    // }

    let savedUsername = localStorage.getItem("username");
    let savedPassword = localStorage.getItem("password");

    if (savedUsername && savedPassword) {
      this.username = savedUsername;
      this.password = savedPassword;
      this.remember = true;
    }
  },
  methods: {
    async forgotPassword() {
      this.$router.push({name: 'ForgotPassword'});
    },
    async register() {
      this.$router.push({name: 'ParentInfo', params: {id: null}});
    },
    async login() {
      try {
        this.loading = true;
        const response = await axios.post(`${BACKEND_URL}/parent-login`, {
          username: this.username,
          password: this.password
        });
        this.userStore.fetchUserInfo();
        this.$router.push('/course-list');
        this.data = response.data;
        this.loading = false;

        if (this.remember) {
          localStorage.setItem("username", this.username);
          localStorage.setItem("password", this.password);
        } else {
          localStorage.removeItem("username");
          localStorage.removeItem("password");
        }
      } catch (error) {
        this.error = error;
        this.loading = false;
        ElMessage.error(error.response?.data?.message || this.$t('Login failed')); // Show error message
      }
    },
    async copyPhoneNumber() {
      if (!this.username) {
        ElMessage.warning(this.$t('Please enter a phone number first.'));
        return;
      }
      try {
        await navigator.clipboard.writeText(this.username);
        ElMessage.success(this.$t('Phone number copied to clipboard!'));
      } catch (err) {
        console.error('Failed to copy: ', err);
        ElMessage.error(this.$t('Failed to copy phone number.'));
      }
    }
  }
};
</script>

<style scoped>
/* Container style */
.container {
  display: flex;
  flex-direction: column;   /* Arrange the elements vertically */
  align-items: flex-start;  /* Align all children to the left */
  justify-content: center;  /* Centers vertically */
  /* min-height: 100vh;       Ensure container takes full viewport height */
  padding: 20px;
  /* width: 100%; */
  max-width: 400px;  /* Optional: Set max width for the container */
  margin: 0 auto;    /* Center container horizontally */
}

/* Label style (aligning them with the inputs) */
label {
  margin-bottom: 5px;  /* Adds space between the label and input */
  font-weight: bold;
}

/* Wrapper for input and icon */
.input-with-icon {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 15px; /* Keep margin consistent */
}

/* Input field common styling */
.input-common {
  /* margin-bottom: 15px; Removed margin-bottom here */
  width: 100%;  /* Makes inputs full width within the container */
  padding: 10px; /* Adjusted padding if needed */
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  flex-grow: 1; /* Allow input to take available space */
}

/* Copy button specific style */
.copy-button {
  margin-left: 8px; /* Add some space between input and button */
  flex-shrink: 0; /* Prevent button from shrinking */
}

/* Button styling */
.btn {
  width: 100%;  /* Make button full-width */
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
}
</style>